<div class="navbar-item dropdown">
  <a href="javascript:;" data-bs-toggle="dropdown" (click)="loadSource()"  class="navbar-link dropdown-toggle icon">
    <i class="fa fa-bell"></i>
    <span class="badge">{{ unreadCount }}</span>
  </a>
  <div class="dropdown-menu media-list dropdown-menu-end" style="width: 30rem;">
    <div class="dropdown-header"   >NOTIFICATIONS ({{ unreadCount }})</div>

    <div class="list-container">
      <dx-list #list [dataSource]="notifications" [height]="600" [searchEnabled]="true" [ngClass]="'notificationBox'"
        [searchExpr]="['quotationNo', 'policyHolderName','quotationId']" searchMode="contains"
        pageLoadMode="scrollBottom">
        <div class="card dropdown-footer pb-0" style="background-color: #e0e0e4;"
          (click)="viewNotification(notification)" *dxTemplate="let notification of 'item'">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-10  ">Policyholder : {{notification?.policyHolderName }} </div>
              <div class="col-md-2 float-right"> <span class="badge bg-info badge-xs"> {{notification?.source }} </span>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-md-6">Group Size &nbsp; : {{notification?.groupSize }}</div>
              <div class="col-md-6 float-right">Inception Date : {{notification?.inceptionDate | date:'MM/dd/yyyy' }}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-md-12"> Quotation # : <a (click)="$event.preventDefault();" class="card-link">{{notification.quotationNo}}</a> 
                
                <span *ngIf="notification?.isQuoted" class="fa fa-check-circle text-success ">
                </span>

              </div>   
            </div>
            
            <div class="row mt-1">
              <p class="col-md-6 col-12 card-text">CreatedBy&nbsp; &nbsp; : {{notification?.createdByName}}</p>
              <p class="col-md-6 col-12 card-text float-right">on {{notification.createdDate | date:'MM/dd/yyyy' }}</p>
            </div>
          </div>
        </div>
      </dx-list>
    </div>
  </div>

  <!-- Toast Container (Top-Right) -->
  <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
    <div #liveToast class="toast hide" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <strong class="me-auto">{{unreadNotification?.quotationNo}}</strong>
        <small>{{unreadNotification?.createdDate | date:'MM/dd/yyyy' }}</small>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
      <div class="toast-body row">
        <div class="col-md-6"> Policyholder : {{unreadNotification?.policyHolderName }} </div>
        <div class="col-md-6"> Group Size : {{unreadNotification?.groupSize }}</div>
        <div class="col-md-6"> Inception Date : {{unreadNotification?.inceptionDate | date:'MM/dd/yyyy' }}</div>
        <div class="col-md-6"> CreatedBy : {{unreadNotification?.createdByName }}</div>
      </div>
    </div>
  </div>

  <!-- {{unreadNotification.message}} -->


  <dx-popup [(visible)]="isPopupVisible" [width]="900" [height]="'auto'" [showTitle]="false" title=""
    [dragEnabled]="true" [closeOnOutsideClick]="false" [toolbarItems]="popupToolbar" [showCloseButton]="true">
    <div class="card popup">
      <h2 class="card-header customSmallHeader rounded-0 fw-bold"><small> <i class="fa fa-list"></i> Health Quotation
          Details
        </small>
      </h2>
      <table class="table table-bordered table-responsive q-compact mt-2">
        <tbody>
          <tr>
            <td class="label-tag">Quotation No</td>
            <td>{{ quotationData?.quotationNo }}</td>
            <td class="label-tag">Option No</td>
            <td>{{ quotationData?.optionId }}</td>
            <td class="label-tag">Quotation Date</td>
            <td>{{ quotationData?.createdDate }}</td>
          </tr>
          <tr>
            <td class="label-tag">Inception Date</td>
            <td>{{ quotationData?.inceptionDate }}</td>
            <td class="label-tag">Policyholder Name</td>
            <td>{{ quotationData?.policyHolderName }}</td>
            <td class="label-tag">Industry</td>
            <td>{{ quotationData?.businessSector }}</td>
          </tr>
          <tr>
            <td class="label-tag">Group Size</td>
            <td>{{ quotationData?.totalMembers }}</td>
            <td class="label-tag">Registration#</td>
            <td>{{ quotationData?.registrationNo }}</td>
            <td class="label-tag">Fresh Group</td>
            <td>{{ quotationData?.isFreshGroup ? 'Yes' : 'No' }}</td>
          </tr>
          <tr>
            <td class="label-tag">Claim Experience</td>
            <td>{{ quotationData?.isClaimExpAvailable ? 'Yes' : 'No' }}</td>
            <td class="label-tag">Claim Specified</td>
            <td>{{ quotationData?.isClaimSpecified ? 'Yes' : 'No' }}</td>
            <td class="label-tag">Status</td>
            <td>{{ quotationData?.externalStatus }}</td>
          </tr>
          <tr>
            <td class="label-tag">Existing Insurer</td>
            <td>{{ quotationData?.existingInsurer }}</td>
            <td class="label-tag">Existing Broker</td>
            <td>{{ quotationData?.existingBroker }}</td>
            <td class="label-tag">Quoting Insurer</td>
            <td>{{ quotationData?.quotingInsurer }}</td>
          </tr>
          <tr>
            <td class="label-tag">Quoting Broker</td>
            <td>{{ quotationData?.quotingBroker }}</td>
          </tr>
        </tbody>
      </table>
      <div class="row mt-2" *ngIf="!quotationData?.quotedMessage">
        <span>Would you like to issue a life quote for this policy holder {{quotationData?.policyHolderName}} ?</span>
      </div>
      <div class="row mt-2" *ngIf="quotationData?.quotedMessage">
        <span> {{quotationData?.quotedMessage}} </span>
      </div>
    </div>

  </dx-popup>